<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1000"
    height="667"
    xmlns:v="https://vecta.io/nano"
  ><path
    fill="#cd879b"
    d="M211.798.762l184.481 319.477L580.723.762z"
  /><path
    fill="#971a40"
    d="M627.958.762l184.5 319.477L996.9.762z"
  /><path
    fill="#a42652"
    d="M603.83.762L418.195 322.201h372.308L604.887.762z"
  /><path
    fill="#ba5b79"
    d="M790.253 341.81l-186.154 322.4-186.135-322.4z"
  /><path
    fill="#dfb5c0"
    d="M187.672.762L2.056 322.201h372.307L188.729.762z"
  /></svg>
</template>
